var _circle, _circle2, _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPetCatDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F85663",
    fillOpacity: 0.05
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23,
    stroke: "#F85663",
    strokeOpacity: 0.1,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9995 12.7676L16.9995 13.7676L18.9996 16.7676L14.8983 19.6561L13.9994 20.7676H12.9995V12.7676Z",
    fill: "#F85663",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4997 18.7676C30.7091 17.977 29.9564 17.224 28.9996 16.2672L30.9997 13.7676L33.9997 12.7676L34.9997 13.7676V20.7676C33.9997 20.7676 31.9997 19.2676 31.4997 18.7676Z",
    fill: "#F85663",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 28.6C36 21.6411 30.6275 16 24 16C17.373 16 12 21.6411 12 28.6C12 33.2395 15.582 37 20 37H28C32.4185 37 36 33.2395 36 28.6Z",
    stroke: "#F85663",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.773 21.3145H19.8809V23.0987H21.6651V21.3145H20.773ZM28.098 23.0987V21.3145H26.3138V23.0987H28.098Z",
    fill: "#F85663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9996 26.1219V28.122C23.9997 28.3846 23.948 28.6446 23.8475 28.8873C23.7471 29.1299 23.5998 29.3504 23.4141 29.5361C23.2284 29.7219 23.0079 29.8693 22.7652 29.9699C22.5225 30.0704 22.2623 30.1221 21.9996 30.1221C20.8951 30.1221 19.9995 29.2265 19.9995 28.122",
    stroke: "#F85663",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 26.1219V28.122C24 28.3846 24.0518 28.6447 24.1524 28.8873C24.2529 29.1299 24.4003 29.3504 24.586 29.5361C24.7716 29.7219 24.9921 29.8692 25.2347 29.9698C25.4773 30.0703 25.7374 30.1221 26 30.1221C27.1051 30.1221 28.0001 29.2265 28.0001 28.122",
    stroke: "#F85663",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9995 26.1211H24.9996",
    stroke: "#F85663",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 26H9",
    stroke: "#F85663",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0001 26H34",
    stroke: "#F85663",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 30H9",
    stroke: "#F85663",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0001 30H34",
    stroke: "#F85663",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0005 22.0928V12.7653C14.9212 12.7654 16.7638 13.5283 18.1221 14.8863L19.4934 16.263",
    stroke: "#F85663",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.038 22.0928L34.9999 12.7655C34.0489 12.7655 33.1071 12.9528 32.2284 13.3167C31.3498 13.6806 30.5514 14.214 29.8788 14.8865L28.4312 16.2632",
    stroke: "#F85663",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetCatDefault);
export default __webpack_public_path__ + "static/media/pet-cat-default.9baf0110.svg";
export { ForwardRef as ReactComponent };